@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.`init`.InitKobwebContext
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Any
import kotlin.Suppress
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import com.rajen.angrejidictionary.components.layouts.MarkdownLayout as _com_rajen_angrejidictionary_components_layouts_MarkdownLayout
import com.rajen.angrejidictionary.components.layouts.PageLayout as _com_rajen_angrejidictionary_components_layouts_PageLayout
import com.rajen.angrejidictionary.pages.AboutPage as _com_rajen_angrejidictionary_pages_AboutPage
import com.rajen.angrejidictionary.pages.ContactPage as _com_rajen_angrejidictionary_pages_ContactPage
import com.rajen.angrejidictionary.pages.HomePage as _com_rajen_angrejidictionary_pages_HomePage
import com.rajen.angrejidictionary.pages.Privacy as _com_rajen_angrejidictionary_pages_Privacy
import com.rajen.angrejidictionary.pages.PrivacyPolicyPage as _com_rajen_angrejidictionary_pages_PrivacyPolicyPage
import com.rajen.angrejidictionary.pages.Terms as _com_rajen_angrejidictionary_pages_Terms
import com.rajen.angrejidictionary.pages.admin.AdminDashboardPage as _com_rajen_angrejidictionary_pages_admin_AdminDashboardPage
import com.rajen.angrejidictionary.pages.admin.AdminLoginPage as _com_rajen_angrejidictionary_pages_admin_AdminLoginPage
import com.rajen.angrejidictionary.pages.word.WordDetailPage as _com_rajen_angrejidictionary_pages_word_WordDetailPage

private val LayoutScopeLocal: ProvidableCompositionLocal<Any?> = compositionLocalOf<Any?> { null }

@Composable
private fun <T : Any> currentLayoutScope(): T {
    @Suppress("UNCHECKED_CAST")
    return LayoutScopeLocal.current as? T
        ?: error("Unexpected between Page/Layout scope and the parent Layout which it is providing it. Please report this issue to the Kobweb developers.")
}

@Composable
private fun <T : Any> provideLayoutScope(layoutScope: T, content: @Composable () -> Unit) {
    androidx.compose.runtime.CompositionLocalProvider(LayoutScopeLocal provides layoutScope, content = content)
}

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Angreji Dictionary"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "com.rajen.angrejidictionary.components.layouts.MarkdownLayout",
            parentLayoutId = "com.rajen.angrejidictionary.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.rajen.angrejidictionary.components.layouts.initMarkdownLayout(ctx)
            },
        ) { pageCtx, pageMethod -> 
            _com_rajen_angrejidictionary_components_layouts_MarkdownLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "com.rajen.angrejidictionary.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _com_rajen_angrejidictionary_components_layouts_PageLayout(pageCtx) {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.register(
            "/",
            layoutId = "com.rajen.angrejidictionary.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.rajen.angrejidictionary.pages.initHomePage(ctx)
            },
        ) { pageCtx -> 
            _com_rajen_angrejidictionary_pages_HomePage()
        }
        ctx.router.register(
            "/about",
            layoutId = "com.rajen.angrejidictionary.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                com.rajen.angrejidictionary.pages.initAboutPage(ctx)
            },
        ) { pageCtx -> 
            _com_rajen_angrejidictionary_pages_AboutPage()
        }
        ctx.router.register(
            "/admin",
            layoutId = "com.rajen.angrejidictionary.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.rajen.angrejidictionary.pages.admin.initAdminDashboard(ctx)
            },
        ) { pageCtx -> 
            _com_rajen_angrejidictionary_pages_admin_AdminDashboardPage()
        }
        ctx.router.register(
            "/admin/login",
            layoutId = "com.rajen.angrejidictionary.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.rajen.angrejidictionary.pages.admin.initAdminLogin(ctx)
            },
        ) { pageCtx -> 
            _com_rajen_angrejidictionary_pages_admin_AdminLoginPage()
        }
        ctx.router.register(
            "/contact",
            layoutId = "com.rajen.angrejidictionary.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.rajen.angrejidictionary.pages.initContact(ctx)
            },
        ) { pageCtx -> 
            _com_rajen_angrejidictionary_pages_ContactPage()
        }
        ctx.router.register(
            "/privacy",
            layoutId = "com.rajen.angrejidictionary.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.rajen.angrejidictionary.pages.initPrivacy(ctx)
            },
        ) { pageCtx -> 
            _com_rajen_angrejidictionary_pages_Privacy()
        }
        ctx.router.register(
            "/privacy-policy",
            layoutId = "com.rajen.angrejidictionary.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                com.rajen.angrejidictionary.pages.initPrivacyPolicyPage(ctx)
            },
        ) { pageCtx -> 
            _com_rajen_angrejidictionary_pages_PrivacyPolicyPage()
        }
        ctx.router.register(
            "/terms",
            layoutId = "com.rajen.angrejidictionary.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.rajen.angrejidictionary.pages.initTerms(ctx)
            },
        ) { pageCtx -> 
            _com_rajen_angrejidictionary_pages_Terms()
        }
        ctx.router.register(
            "/word/{word}",
            layoutId = "com.rajen.angrejidictionary.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                com.rajen.angrejidictionary.pages.word.initWordDetailPage(ctx)
            },
        ) { pageCtx -> 
            _com_rajen_angrejidictionary_pages_word_WordDetailPage()
        }

        com.rajen.angrejidictionary.setCustomErrorPage(ctx)
    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("footer", com.rajen.angrejidictionary.components.sections.FooterStyle)
        ctx.theme.registerStyle("footer-row", com.rajen.angrejidictionary.components.sections.FooterRowStyle)
        ctx.theme.registerStyle("social-links", com.rajen.angrejidictionary.components.sections.SocialLinksStyle)
        ctx.theme.registerStyle("footer-link", com.rajen.angrejidictionary.components.sections.FooterLinkStyle)
        ctx.theme.registerStyle("copyright", com.rajen.angrejidictionary.components.sections.CopyrightStyle)
        ctx.theme.registerStyle("footer-link-active", com.rajen.angrejidictionary.components.sections.FooterLinkActiveStyle)
        ctx.theme.registerStyle("header", com.rajen.angrejidictionary.components.sections.HeaderStyle)
        ctx.theme.registerStyle("header-shadow", com.rajen.angrejidictionary.components.sections.HeaderShadowStyle)
        ctx.theme.registerStyle("page-content", com.rajen.angrejidictionary.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("markdown", com.rajen.angrejidictionary.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("word-card", com.rajen.angrejidictionary.components.widgets.WordCardStyle)
        ctx.theme.registerStyle("headline-text", com.rajen.angrejidictionary.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", com.rajen.angrejidictionary.SubheadlineTextStyle)
        ctx.theme.registerStyle("hero-container", com.rajen.angrejidictionary.pages.HeroContainerStyle)
        ctx.theme.registerStyle("home-grid", com.rajen.angrejidictionary.pages.HomeGridStyle)
        ctx.theme.registerStyle("home-grid-cell", com.rajen.angrejidictionary.pages.HomeGridCellStyle)
        ctx.theme.registerStyle("suggestion-card", com.rajen.angrejidictionary.pages.admin.SuggestionCardStyle)
        ctx.theme.registerStyle("admin-dashboard-card", com.rajen.angrejidictionary.pages.admin.AdminDashboardCardStyle)
        ctx.theme.registerStyle("admin-tab-bar", com.rajen.angrejidictionary.pages.admin.AdminTabBarStyle)
        ctx.theme.registerStyle("active-tab", com.rajen.angrejidictionary.pages.admin.ActiveTabStyle)
        ctx.theme.registerStyle("inactive-tab", com.rajen.angrejidictionary.pages.admin.InactiveTabStyle)
        ctx.theme.registerStyle("success", com.rajen.angrejidictionary.pages.admin.SuccessStyle)
        ctx.theme.registerStyle("preview-card", com.rajen.angrejidictionary.pages.admin.PreviewCardStyle)
        ctx.theme.registerStyle("admin-word-card", com.rajen.angrejidictionary.pages.admin.AdminWordCardStyle)
        ctx.theme.registerStyle("admin-word-link", com.rajen.angrejidictionary.pages.admin.AdminWordLinkStyle)
        ctx.theme.registerStyle("word-of-day-panel", com.rajen.angrejidictionary.pages.admin.WordOfDayPanelStyle)
        ctx.theme.registerStyle("admin-outline-button", com.rajen.angrejidictionary.pages.admin.AdminOutlineButtonStyle)
        ctx.theme.registerStyle("add-word-layout", com.rajen.angrejidictionary.pages.admin.AddWordLayoutStyle)
        ctx.theme.registerStyle("add-word-input-column", com.rajen.angrejidictionary.pages.admin.AddWordInputColumnStyle)
        ctx.theme.registerStyle("add-word-preview-column", com.rajen.angrejidictionary.pages.admin.AddWordPreviewColumnStyle)
        ctx.theme.registerStyle("admin-card", com.rajen.angrejidictionary.pages.admin.AdminCardStyle)
        ctx.theme.registerStyle("admin-error", com.rajen.angrejidictionary.pages.admin.AdminErrorStyle)
        ctx.theme.registerStyle("admin-button", com.rajen.angrejidictionary.pages.admin.AdminButtonStyle)
        ctx.theme.registerVariant("-circle", com.rajen.angrejidictionary.CircleButtonVariant
        )
        ctx.theme.registerVariant("-uncolored", com.rajen.angrejidictionary.UncoloredButtonVariant
        )
        com.rajen.angrejidictionary.initColorMode(ctx)
        com.rajen.angrejidictionary.initStyles(ctx)
        com.rajen.angrejidictionary.initTheme(ctx)
        com.rajen.angrejidictionary.initSiteStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.rajen.angrejidictionary.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
